import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { IKeyValueInterface, RoleLevel } from './../../shared/config';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  Permission,
  PermissionType,
  Entity,
  WeGoAuthorizedLink
} from '../../shared/config';
import { Location } from '@angular/common';
import { OrganizationService } from '../../organization/models/organization.service';
import { OrganizationDriverService } from '../models/organization-driver.service';
import { OrganizationDriverModel } from '../models/organization-driver.model';
import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { PersonService } from '../../person/models/person.service';
import { OrganizationDriverInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';

@Component({
  selector: 'wego-organization-driver-mapping',
  template: require('../views/organization-driver-list.component.html'),
  providers: [OrganizationService, OrganizationDriverService, PersonService]
})
export class OrganizationDriverListComponent implements OnInit {
  urlVehicleUpdate: string;
  DataListModel: DataListModel;
  driverList: OrganizationDriverModel[];
  errorMessage: string;
  isLoading: boolean;
  message: string;
  OrganizationHashId: string = '';
  deleteDriverMapHashId: string;
  organizationName: string;
  isParentCheck: boolean;
  apiResponse: IAPIResponse;
  urlDefaultPage: string;
  urlOrganizationList: string;
  resetPasswordPersonHashId: string;
  inviteTitle: string;
  LblAddDriverToOrganization: string;
  sub: any;
  addOrganizationDriverLink: any;
  roleLevel = RoleLevel;

  private validationMessage: string;
  private popupTitle: string;
  private popupMsg: string;
  private module: string;

  @ViewChild('deleteModal') public deleteModal: any;
  // @ViewChild('assignDriverToOrganizationModal') public assignDriverToOrganizationModal: any;
  @ViewChild('inviteDriverModal') public inviteDriverModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('alertModal') public alertModal: ModalDirective;

  get isAnyChecked(): boolean {
    if (this.driverList) {
      let isCheck = this.driverList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.driverList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(
    private organizationService: OrganizationService,
    private organizationDriverService: OrganizationDriverService,
    private personService: PersonService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) {}

  ngOnInit() {
    this.module = this.translate.instant('LblDriver');
    this.inviteTitle =
      this.translate.instant('LblInvite') +
      ' ' +
      this.translate.instant('LblDriver');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ['driverName', 'firstName', 'lastName'];
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlOrganizationList = this.authService.GetURL(
      ApplicationRouteURL.URL_ORGANIZATION_LIST
    );
    this.LblAddDriverToOrganization = this.translate.instant(
      'LblAddDriverToOrganization'
    );
    this.sub = this.activeRoute.params.subscribe(params => {
      let OrganizationHashId = params['id'] || '';
      if (OrganizationHashId != '') {
        this.OrganizationHashId = OrganizationHashId;
        this.GetDriverListByOrganizationList();
        this.GetOrganizationDetailByHashId();
        this.addOrganizationDriverLink = new WeGoAuthorizedLink(
          '',
          Permission.PR_ORGANIZATION_DRIVER_OVERVIEW,
          PermissionType.INSERT,
          'btn btn-highlight navbar-right',
          'LblAddDriver',
          Entity.ORGANIZATION,
          this.OrganizationHashId
        );
      }
    });
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.organizationDriverService
      .ExportDriverList(this.OrganizationHashId, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName =
              'DriverToOrganization' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverListByOrganizationList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetDriverListByOrganizationList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverListByOrganizationList();
  }

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverListByOrganizationList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList
      .filter(x => x.isDeletable)
      .forEach(x => (x.isChecked = isChecked));
  }

  public DeleteDriverMapping(organizationToDriverMapHashId: string) {
    this.isLoading = true;
    this.organizationDriverService
      .DeleteDriverMapping(organizationToDriverMapHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.apiResponse = res;
            this.DataListModel.currentPage = 1;
            this.GetDriverListByOrganizationList();
            this.ShowDeleteSuccessPopup();
          } else {
            this.validationMessage = res.error;
            this.popupTitle = this.translate.instant('LblWarning');
            this.ShowAlertModal();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowDeleteModal(organizationToDriverMapHashId: string): void {
    this.deleteDriverMapHashId = organizationToDriverMapHashId;
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [
      this.module
    ]);
    this.deleteModal.show();
  }

  public HideDeleteModal(): void {
    this.deleteDriverMapHashId = '';
    this.deleteModal.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteDriverMapping(this.deleteDriverMapHashId);
    this.deleteModal.hide();
  }

  public GetDriverListByOrganizationList() {
    this.isLoading = true;
    this.organizationDriverService
      .GetDriverListByOrganizationHashId(
        this.OrganizationHashId,
        this.DataListModel
      )
      .subscribe(
        res => {
          this.driverList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetOrganizationDetailByHashId() {
    this.organizationService
      .GetOrganizationBasicDetail(this.OrganizationHashId)
      .subscribe(
        res => {
          this.organizationName = res.data.entityName;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  // public ShowAssignDriverToOrganizationModal() {
  //   this.assignDriverToOrganizationModal.OrganizationHashId = this.OrganizationHashId;
  //   this.assignDriverToOrganizationModal.show();
  // }

  public ShowAddOrganizationDriverModal() {
    this.ShowInviteDriverModal();
  }

  public SuccessAssignDriverModal($event: any) {
    this.GetDriverListByOrganizationList();
    this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [
      this.module
    ]);
    this.ShowSuccessPopup();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public ShowDeleteSuccessPopup(): void {
    this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
      this.module
    ]);
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = '';
    this.resetPasswordModal.hide();
  }

  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  //Reset group admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID, this.OrganizationHashId).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblResendActivationMailFailure'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ShowInviteDriverModal(): void {
    this.inviteDriverModal.availableRoles = [];
    this.inviteDriverModal.availablePersons = '';
    this.inviteDriverModal.show();
  }

  public HideInviteDriverModal(): void {
    this.inviteDriverModal.hide();
  }

  public SuccessInviteDriverModalClick($event: any): void {
    let driverInvitation = new OrganizationDriverInvitationModel();
    driverInvitation.emailAddress = $event.emailAddress;
    driverInvitation.personHashId = $event.personHashId;
    driverInvitation.roleHashIdList = [];
    driverInvitation.organizationHashId = this.OrganizationHashId;
    driverInvitation.userName = $event.UserName;
    driverInvitation.rfidTagId = $event.rfidTagId;
    this.organizationDriverService
      .InviteAdminOfOrganization(driverInvitation)
      .subscribe(
        res => {
          if (res.data) {
            if (driverInvitation.personHashId == '0')
              this.popupMsg = this.translate.instant('LblAddDriverSuccessMsg');
            else {
              this.popupMsg = this.translate.instant(
                'LblExistingDriverAddSuccessMsg'
              );
            }
            this.HideInviteDriverModal();
            this.ShowSuccessPopup();
            this.GetDriverListByOrganizationList();
          } else {
            this.inviteDriverModal.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideInviteDriverModal();
        }
      );
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.organizationDriverService
      .GetPersonListToInvite(this.OrganizationHashId, emailAddress)
      .subscribe(
        res => {
          if (res.data) {
            this.inviteDriverModal.availablePersons = res.data;
            this.inviteDriverModal.errorModel = [];
          } else {
            this.inviteDriverModal.errorModel = res.error;
          }
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationdriver/components/organization-driver-list.component.ts